import { AbstractControl, FormControl, ValidatorFn } from "@angular/forms";

export const WhiteSpaceValidator: ValidatorFn = (control: FormControl) => {
    if (isNullOrUndefined(control.value).trim().length === 0) {
        return {
            'whiteSpacesError': { value: 'control tiene espacios sin caracteres' }
        };
    }
    return null;
};
export const trimStartEndValidator: ValidatorFn = (control: FormControl) => {
    if (isNullOrUndefined(control.value).startsWith(' ')) {
        return {
            'trimStartEndError': { value: 'control has leading whitespace' }
        };
    }
    if (isNullOrUndefined(control.value).endsWith(' ')) {
        return {
            'trimStartEndError': { value: 'control has trailing whitespace' }
        };
    }
    return null;
};
export const withoutSpacesValidator: ValidatorFn = (control: FormControl) => {
    if (isNullOrUndefined(control.value).trim().length === 0 || control.value.includes(' ')) {
        return {
            'withoutSpaceError': { value: 'control has whitespace' }
        };
    }
    return null;
};
export const rfcValidator: ValidatorFn = (control: FormControl) => {
    const re = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
    var validado = isNullOrUndefined(control.value).match(re);
    if (!validado) {
        return {
            'rfcValidatorError': { value: 'RFC no válido' }
        };
    }
    return null;
};
export function telOnlyNumbersValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const regex = /^[0-9]{0,10}$/;
        const valid = regex.test(control.value);
        return valid ? null : { 'telOnlyNumbers': { value: control.value } };
    };
}

export function onlyLettersValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*$/;
        const valid = regex.test(control.value);
        return valid ? null : { 'onlyLetters': { value: control.value } };
    };
}

function isNullOrUndefined(valor, validarVacios: boolean = false) {
    let cond: boolean = (valor === null || valor === undefined || (validarVacios && (typeof valor === 'string' && valor.trim() === "")));

    return cond ? "" : valor;
}
